import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%'
  },
  button: {
    marginRight: theme.spacing(1)
  },
  header: {
    marginBottom: 30,
    textAlign: 'center'
  },
  title: {
    position: 'relative'
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  formButtonsContainer: {
    backgroundColor: theme.palette.background.default,
    position: 'sticky',
    margin: 'auto',
    width: '100%',
    padding: '20px 0 30px 0',
    borderTop: `1px solid ${theme.palette.grey[400]}`,
    bottom: 0,
    textAlign: 'right'
  },
  stepper: {
    marginBottom: 30,
    backgroundColor: theme.palette.background.default,
    [theme.breakpoints.down('sm')]: {
      padding: '24px 0'
    }
  },
  stepsContentContainer: {
    width: '80%',
    margin: 'auto',
    [theme.breakpoints.down('sm')]: {
      width: '95%'
    },
    [theme.breakpoints.down(1337)]: {
      width: '100%'
    }
  },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.primary.main
  }
}))

export default useStyles
